import { render } from "./MainLayout.vue?vue&type=template&id=40a932fa&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=40a932fa&scoped=true&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=40a932fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a932fa"]])

export default __exports__